module.exports =  {

  whatIsMyTokens: {
    title: 'What Is "My Tokens"?',
    contents: `
      <p>This is the place to track and manage your tokens. You can add any ERC20 tokens to
      your tracked token list. You can remove tracked tokens if you want. For each tracked
      token, you can see its balance, set allowance, search buy/sell orders for this token and
      send token to other addresses.</p>
    `,
  },

  howToGetStarted: {
    title: 'How to Get Started?',
    contents: `
      <ul class="mb-2">
        <li><strong>Wrap ETH</strong>: ETH cannot be traded with other tokens directly. You
          need to wrap it (convert it to WETH) first. WETH can be converted back to ETH (unwrapped)
          at any time.</li>
        <li><strong>Set Token Allowance</strong>: In order for the smart contract to execute your trades, you need to give the smart contract access to your tokens. This access is called "allowance".</li>
      </ul>
    `,
  },

  whatAreWETHWrapUnwrap: {
    title: 'What Are WETH, Wrapping and Unwrapping?',
    contents: `
      <p>WETH is "Wrapped Ether". Since Ether (ETH) itself is not an ERC20 token and cannot be traded
        with other ERC20 tokens directly, you need to convert your ETH into WETH, which is a ERC20 token
        that's always 1:1 to ETH. WETH can be connverted back to ETH at any time. Converting ETH to WETH
        is called "wraping" and converting WETH back to ETH is called "unwrapping".
      </p>
    `,
  },

  whatIsAllowance: {
    title: 'What Is Allowance?',
    contents: `
      <p>In order for the smart contract to execute your trades, you need to grant the smart contract
      permission to access to your tokens. This permission is called "allowance". For each token that
      you want to sell, you need to set allowance first for that token before you can create the
      order. When you want to fill an existing order with a token (which is the taker token), you
      also need to have allowance for the taker token before you can fill the order.
      </p>
    `,
  },

  howToAddNewToken: {
    title: 'How to Add a New Token?',
    contents: `
      <p>To add a new token, you need to visit the "My Tokens" page and click on the big green "+" sign on
       that page. Then you will see a pop-up
        window, where you can either select from a list of verified popular tokens or search for your token
       by entering its contract address. </p>
    `,
  },

  howToRemoveToken: {
    title: 'How to Stop Tracking a Token?',
    contents: `
      <p>To remove a token from your tracking list, you need to go to the page for that token, then
       click on the "Remove Tracking" button. Removing a token from your tracked token list does not affect
        your ownership or balance for that token. You can add removed token back later on.
       </p>
    `,
  },

  howToFindOrdersForAToken: {
    title: 'How to Find Orders for a Token?',
    contents: `
      <p>For each token, you can search for open orders that sell or buy that token. To see orders
        selling that token, click on the "Sell" dropdown button and you will see a list of trading
        pairs where that token is the maker token and the taker token is one of the other tokens on
        your token list. Similarly, by clicking on the "Buy" dropdown button you will see trading
        pairs in which that token is the taker token. Once you have selected the token pair, click
        on it and you will go to the marketplace page to see the current orders.
       </p>
    `,
  },

  couldNotFindTokenPair: {
    title: "How Come I Couldn't Find the Token Pairs I'm Interested In?",
    contents: `
      <p>The trading pairs listed on the "Buy" or "Sell" dropdown menus only include tokens on your
        token tracking list. To see other tokens, you need to add that token to your token tracking
        list first.
       </p>
    `,
  },

}
